module.exports = __webpack_public_path__ + "assets/img/logo.34bad2d5.png";